export default "__VITE_ASSET__Dmoiqcyo__"